import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AppBundle } from 'api/optimalprint-sdk.d';
import setPricesToFetchOperation from 'store/price/operation/setPricesToFetchOperation';
import collectPricesFromMoreArePrints from 'utils/price/collectPricesFromMoreArePrints';
import { setMoreArtPrintsAction } from '../slice';
import getEncPublicDesignId from '../selector/getEncPublicDesignId';

const fetchMoreArtPrintsOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const encDesignId = getEncPublicDesignId(store);
    const moreArtPrints = (await apiRequest(
      endpoints.categoryV3DesignsSearch,
      {
        filter: {
          authorFromEncryptedDesignId: encDesignId,
        },
      },
      HttpMethods.POST,
      'data',
    )) as AppBundle.Api.Response.Category.V3.SearchDesignsV3Response;

    const prices = collectPricesFromMoreArePrints(moreArtPrints.designs);
    dispatch(setPricesToFetchOperation(prices));
    dispatch(setMoreArtPrintsAction(moreArtPrints.designs));
  };

export default fetchMoreArtPrintsOperation;
